import { render, staticRenderFns } from "./SettingsCreateOrderCategory.vue?vue&type=template&id=72ff8055&scoped=true"
import script from "./SettingsCreateOrderCategory.vue?vue&type=script&lang=js"
export * from "./SettingsCreateOrderCategory.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateOrderCategory.vue?vue&type=style&index=0&id=72ff8055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff8055",
  null
  
)

export default component.exports